import { useState } from 'react';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/react';
import { Refresh } from '~/components/AssetStore';
import {
  useGetAssetAvatarListQuery,
  useGetAssetFileUrlListMutation,
} from '~/features/assetStore';
import Characters from './Characters';
import StoreCanvas from './StoreCanvas';

export type SelectedAvatar = {
  id: string;
  characterUrl: string;
};

export default function Avatar() {
  const { data } = useGetAssetAvatarListQuery();
  const [character, setCharacter] = useState<SelectedAvatar>();
  const { mutate } = useGetAssetFileUrlListMutation();

  const handleAvatarClick = async (id: string) => {
    if (character?.id === id) return;

    mutate(
      { id, type: 'character' },
      {
        onSuccess(response) {
          setCharacter({
            id,
            characterUrl: response.data as string,
          });
        },
      },
    );
  };

  return (
    <Container>
      <Sentry.ErrorBoundary fallback={undefined}>
        <StoreCanvas character={character} />
      </Sentry.ErrorBoundary>

      <Characters
        data={data}
        handleAvatarClick={handleAvatarClick}
        selectedId={character?.id}
      />
      <Refresh />
    </Container>
  );
}

export const Container = styled.div`
  display: block;
  position: relative;
  width: 100%;
  height: ${(props) => props.theme.layout.assetStore_canvas_height};
`;
